/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";

const ServiceToggle = defineComponent<{
  icon: string;
  title: string;
  description: string;
  checked: boolean;
  onUpdate: (checked: boolean) => void;
}>({
  name: "ServiceToggle",
  props: ["icon", "title", "description", "checked", "onUpdate"],
  setup(props) {
    return () => (
      <div class="form-control">
        <label class="cursor-pointer">
          <div class="flex items-center justify-between p-4 border-2  rounded-xl hover:border-primary transition-all">
            <div class="flex items-center gap-3">
              <span class="material-symbols-outlined text-2xl text-base-content/70">
                {props.icon}
              </span>
              <div>
                <span class="label-text font-semibold text-base">
                  {props.title}
                </span>
                <p class="text-xs text-base-content/60 mt-0.5">
                  {props.description}
                </p>
              </div>
            </div>
            <input
              type="checkbox"
              checked={props.checked}
              class="toggle toggle-primary"
              onChange={(event: Event) =>
                props.onUpdate((event.target as HTMLInputElement).checked)
              }
            />
          </div>
        </label>
      </div>
    );
  },
});

export const ServiceOptionsCard = defineComponent<{
  takeAway: "yes" | "no";
  delivery: "yes" | "no";
  onUpdateTakeAway: (value: "yes" | "no") => void;
  onUpdateDelivery: (value: "yes" | "no") => void;
}>({
  name: "ServiceOptionsCard",
  props: ["takeAway", "delivery", "onUpdateTakeAway", "onUpdateDelivery"],
  setup(props) {
    const { t } = useLocalization();

    return () => (
      <div class="l-box-shadow rounded rounded-2xl shadow-xl bg-base-100 border border-base-100">
        <div class="card-body">
          <div class="flex items-center gap-3 mb-6">
            <div class="p-3 bg-success/10 rounded-xl">
              <span class="material-symbols-outlined text-success text-2xl">
                delivery_dining
              </span>
            </div>
            <div class="flex-1">
              <h3 class="text-lg font-semibold text-accent">
                {t("settings.config.service_options")}
              </h3>
              <p class="text-sm text-base-content">
                {t("settings.config.service_options_desc")}
              </p>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <ServiceToggle
              icon="takeout_dining"
              title={t("settings.config.takeaway")}
              description={t("settings.config.takeaway_desc")}
              checked={props.takeAway === "yes"}
              onUpdate={(checked) =>
                props.onUpdateTakeAway(checked ? "yes" : "no")
              }
            />
            <ServiceToggle
              icon="local_shipping"
              title={t("settings.config.delivery")}
              description={t("settings.config.delivery_desc")}
              checked={props.delivery === "yes"}
              onUpdate={(checked) =>
                props.onUpdateDelivery(checked ? "yes" : "no")
              }
            />
          </div>
        </div>
      </div>
    );
  },
});
